<template>
  <section aria-roledescription="carousel" :aria-label="props.carouselTitle">
    <v-carousel color="#0d2154" :interval="carouselInterval" :cycle="carouselCycle" :height="props.carouselHeight"
      hide-delimiter-background hide-delimiters style="background-color: #EEEEEE;">

      <template v-slot:prev="{ props }">
        <div style="background-color: #EEEEEE; 
          position: absolute; 
          width: 55px; 
          height: 20px; 
          bottom: 0px; 
          left: 5px; 
          z-index: 100;
          border-top-left-radius: 25px;
          border-bottom-left-radius: 25px;
          color: #6E6E6E;">
          <v-btn color="#6E6E6E" variant="plain" @click="props.onClick" icon
            style="position: absolute; bottom: -6px; left: -5px; z-index: 102;" aria-label="Previous Slide"
            size="x-small">
            <v-icon size="x-large" icon="mdi-arrow-left-bold-circle" />
          </v-btn>
        </div>
      </template>

      <template v-slot:next="{ props }">
        <div style="background-color: #EEEEEE; 
          position: absolute; 
          width: 60px; 
          height: 20px; 
          bottom: 0px; 
          left: 33px; 
          z-index: 100;
          border-top-right-radius: 25px;
          border-bottom-right-radius: 25px;
          color: #6E6E6E;">
          <v-btn color="#6E6E6E" variant="plain" @click="props.onClick" icon
            style="position: absolute; bottom: -6px; right: -5px; z-index: 102;" aria-label="Next Slide" size="x-small">
            <v-icon size="x-large" icon="mdi-arrow-right-bold-circle" />
          </v-btn>

          <v-btn color="#6E6E6E" variant="plain" @click="carouselCycle = !carouselCycle" icon
            style="position: absolute; bottom: -6px; left: 0px; z-index: 102;" aria-label="Stop automatic slide show"
            size="x-small">
            <v-icon size="x-large" :icon="carouselPauseResume" />
          </v-btn>
        </div>
      </template>


      <v-carousel-item v-for="item in props.carouselItems" fill :src="getImgUrl(item)" height="100%" width="100%" role="group"
        aria-label="slide {{ item.item }} of 2" aria-roledescription="slide" @mouseover="carouselCycle = false"
        @mouseout="carouselCycle = true" alt="Carousel Image">

          <div v-if="item.customLanguageContent !== undefined" class="fill-height fill-width">
            
            <div v-if="item.isClickable" class=""
              @click="getCustomClickEvent(item)" style="cursor: pointer; width: 100%; height: 100%;">
            </div>

        </div>
        <div
          v-else-if="item.customLanguageContent === undefined" class="fill-height fill-width">
          
            <div v-if="item.isClickable" class="carousel-heading ma-0 pa-0"
              @click="systemStore.routerTo(item.route)" style="cursor: pointer; width: 100%; height: 100%;">
              <LanguagePlaceholder is-html :default-text="item.title" />
            </div>

            <div v-else-if="!item.isClickable" class="general-carousel-heading" style="width: 100%; height: 100%;">
              {{ item.title }}
            </div>

        </div>

      </v-carousel-item>
    </v-carousel>
  </section>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const systemStore = useSystemStore()

const carouselInterval = ref(4000)
const carouselPauseResume = ref('mdi-pause-circle')
const carouselCycle = ref(true)

const props = defineProps({
  carouselHeight: { type: String, default: '250' },
  carouselTitle: { type: String, default: '' },
  carouselItems: { type: Array, default: [] }
})

watch(
  carouselCycle,
  () => {
    carouselPauseResume.value = carouselCycle.value ? 'mdi-pause-circle' : 'mdi-play-circle'
  }
)

const getImgUrl = (item) => {

  var lng = systemStore.selectedLanguage
  
    if (item.customLanguageContent !== undefined){
      if (item.customLanguageContent[lng] !== undefined) {
        return item.customLanguageContent[lng].imgUrl
      } else {
        return item.customLanguageContent['en'].imgUrl // Fallback to English if the selected language is not available
      }
    } else {
      return item.url
    }

}

const getCustomClickEvent = (item) => {

  var lng = systemStore.selectedLanguage  
  var itm = item.customLanguageContent[lng]

  if (itm !== undefined)
    return itm.clickEvent()
  else
    return item.customLanguageContent['en'].clickEvent() // Fallback to English if the selected language is not available

}

</script>